export default "__VITE_ASSET__rP6O4eN9__"